// import { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Heading,
//   Box,
//   Text,
//   Flex,
//   VStack,
//   Button,
//   Image,
//   Spacer,
//   OrderedList,
//   ListItem,
//   useToast,
//   useDisclosure,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalBody,
//   Spinner,
//   Input,
//   Alert,
//   AlertIcon,
//   Center,
//   useMediaQuery,
// } from "@chakra-ui/react";
// import course from "../images/girl.gif";
// import bars from "../images/bars.png";
// import NavBar from "../components/NavBar";
// import Footer from "../components/Footer";
// import { useSelector } from "react-redux";

// const IDetail = () => {
//   const { id } = useParams();
//   const [internshipDetails, setInternshipDetails] = useState(null);
//   const { isAdmin } = useSelector((state) => state.user);
//   const [paymentStatus, setPaymentStatus] = useState(null);
//   const [isPaymentCompleted, setIsPaymentCompleted] = useState(false);
//   const [showResumeUpload, setShowResumeUpload] = useState(false);
//   const [hasApplied, setHasApplied] = useState(false);
//   const [resumeUploaded, setResumeUploaded] = useState(false);
//   const [showResumeAlert, setShowResumeAlert] = useState(false);

//   const toast = useToast();
//   const [isLoading, setIsLoading] = useState(false);
//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const navigate = useNavigate();
//   const [isMobile] = useMediaQuery("(max-width: 900px)");
//   const [isTablet] = useMediaQuery("(max-width: 1070px)");

//   const handlePaymentStatus = async () => {
//     const accessToken = window.sessionStorage.getItem("accessToken");
//     const merchant_id = window.sessionStorage.getItem("merchant_id");

//     if (!merchant_id) {
//       toast({
//         title: "Error",
//         description: "Merchant ID is missing.",
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//       return;
//     }

//     try {
//       const response = await axios.post(
//         "https://gyanbackend.aim4u.co.in/intern/payment-status/",
//         { merchant_order_id: merchant_id },
//         {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//           },
//         }
//       );

//       const { status, details } = response.data;

//       if (status === "Payment incomplete or failed") {
//         const errorDetails = details?.error_code
//           ? `Error Code: ${details.error_code}`
//           : "Please try again later.";

//         toast({
//           title: "Payment Failed",
//           description: errorDetails,
//           status: "error",
//           duration: 5000,
//           isClosable: true,
//         });
//       } else if (details?.status === "PENDING") {
//         toast({
//           title: "Payment Pending",
//           description: "Your payment is still being processed. Please wait a few minutes.",
//           status: "warning",
//           duration: 5000,
//           isClosable: true,
//         });
//       } else if (details?.status === "SUCCESS") {
//         setIsPaymentCompleted(true);
//         toast({
//           title: "Payment Successful",
//           description: `Order ID: ${details.order_id}`,
//           status: "success",
//           duration: 5000,
//           isClosable: true,
//         });
//       }
//     } catch (error) {
//       toast({
//         title: "Error",
//         description: error.response?.data?.message || "Failed to fetch payment status.",
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//       console.error("Payment status error:", error);
//     }
//   };

//   const handlePayment = async () => {
//     if (!id) {
//       toast({
//         title: "Error",
//         description: "Internship ID is missing",
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//       return;
//     }

//     setIsLoading(true);
//     onOpen();

//     try {
//       const accessToken = window.sessionStorage.getItem("accessToken");

//       const response = await axios.post(
//         "https://gyanbackend.aim4u.co.in/intern/gyan-payment/",
//         { internship_id: id },
//         {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//           },
//         }
//       );

//       if (response.data && response.data.redirect_url) {
//         window.sessionStorage.setItem("merchant_id", response.data.merchant_order_id);

//         setTimeout(() => {
//           setIsLoading(false);
//           onClose();
//           window.location.href = response.data.redirect_url;

//           setTimeout(() => {
//             handlePaymentStatus();
//           }, 3000);
//         }, 1500);
//       } else {
//         throw new Error("No redirect URL received from payment gateway");
//       }
//     } catch (error) {
//       setIsLoading(false);
//       onClose();

//       toast({
//         title: "Payment Failed",
//         description: error.response?.data?.message || "Something went wrong with the payment process",
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//       console.error("Payment error:", error);
//     }
//   };
//   const handleResumeUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setIsLoading(true); // Keep this to show spinner in button

//     const reader = new FileReader();
//     reader.onload = () => {
//       localStorage.setItem("user_resume", reader.result);
//       setResumeUploaded(true);
//       setShowResumeAlert(false);
//       setIsLoading(false);

//       toast({
//         title: "Resume Uploaded",
//         description: "Your resume has been successfully uploaded",
//         status: "success",
//         duration: 3000,
//         isClosable: true,
//       });
//     };
//     reader.onerror = () => {
//       setIsLoading(false);
//       toast({
//         title: "Error",
//         description: "Failed to upload resume",
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     };
//     reader.readAsDataURL(file);
//   };


//   const handleCompleteApplication = () => {
//     if (!resumeUploaded) {
//       setShowResumeAlert(true);
//       return;
//     }
//     handleApply();
//   };

//   const handleApply = async () => {
//     if (!id) {
//       toast({
//         title: "Error",
//         description: "Internship ID is missing",
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//       return;
//     }

//     // Start loading state but don't use the payment modal here
//     setIsLoading(true);

//     // Only show a processing state without opening the payment modal
//     const processingToast = toast({
//       title: "Processing",
//       description: "Submitting your application...",
//       status: "info",
//       duration: null,
//       isClosable: false,
//     });

//     try {
//       const accessToken = window.sessionStorage.getItem("accessToken");
//       const resumeData = localStorage.getItem("user_resume");

//       // First apply for the internship
//       const applyResponse = await axios.post(
//         "https://gyanbackend.aim4u.co.in/intern/apply/",
//         { internship_id: id },
//         {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       // Then upload the resume if available
//       if (resumeData) {
//         const blob = await fetch(resumeData).then(r => r.blob());
//         const file = new File([blob], "resume.pdf", { type: "application/pdf" });

//         const formData = new FormData();
//         formData.append("internship_id", id);
//         formData.append("resume_file", file);

//         await axios.post(
//           "https://gyanbackend.aim4u.co.in/upload-internship-resume/",
//           formData,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         );
//       }

//       // Close the processing toast
//       toast.close(processingToast);

//       toast({
//         title: "Success",
//         description: applyResponse.data.message,
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });

//       setHasApplied(true);
//       setShowResumeUpload(false);
//       setIsLoading(false);
//       fetchApplicationStatus();
//     } catch (error) {
//       // Close the processing toast
//       toast.close(processingToast);

//       setIsLoading(false);

//       toast({
//         title: "Apply Failed",
//         description:
//           error.response?.data?.message ||
//           "Something went wrong while applying",
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });

//       console.error("Apply error:", error);
//     }
//   };

//   const fetchInternshipDetails = async () => {
//     try {
//       const response = await axios.get("https://gyanbackend.aim4u.co.in/intern/all-internship/");
//       const selectedInternship = response.data.find(
//         (internship) => internship.id === Number.parseInt(id, 10)
//       );

//       if (selectedInternship) {
//         setInternshipDetails(selectedInternship);
//       }
//     } catch (error) {
//       console.error("Error fetching internship details:", error);
//       toast({
//         title: "Error",
//         description: "Failed to load internship details",
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   };

//   const fetchApplicationStatus = async () => {
//     try {
//       const currentUser = JSON.parse(sessionStorage.getItem("user"));
//       const internshipTitle = internshipDetails?.Internship_title;

//       if (!currentUser || !internshipTitle) return;

//       const response = await axios.get("https://gyanbackend.aim4u.co.in/intern/get-status/", {
//         params: {
//           user: currentUser.email,
//           internship: internshipTitle,
//         },
//       });

//       setPaymentStatus(response.data.status);
//     } catch (error) {
//       console.error("Error fetching payment status:", error);
//       setPaymentStatus("Unavailable");
//     }
//   };

//   const fetchPaymentStatus = async () => {
//     try {
//       const currentUser = JSON.parse(sessionStorage.getItem("user"));
//       const internshipTitle = internshipDetails?.Internship_title;

//       if (!currentUser || !internshipTitle) return;

//       const response = await axios.get("https://gyanbackend.aim4u.co.in/intern/get-payment-status/", {
//         params: {
//           user: currentUser.email,
//           internship: internshipTitle,
//         },
//       });

//       if (response.data.payment_status === "COMPLETED") {
//         setIsPaymentCompleted(true);
//       } else {
//         setIsPaymentCompleted(false);
//       }
//     } catch (error) {
//       console.error("Error fetching payment status:", error);
//       setIsPaymentCompleted(false);
//     }
//   };

//   useEffect(() => {
//     if (id) {
//       fetchInternshipDetails();
//     }
//   }, [id, toast]);

//   useEffect(() => {
//     if (internshipDetails) {
//       fetchApplicationStatus();
//     }
//   }, [internshipDetails]);

//   useEffect(() => {
//     if (document.referrer?.includes("phonepe")) {
//       console.log("FROM PHONEPE");
//       handlePaymentStatus();
//       fetchPaymentStatus();
//     }
//   }, []);

//   useEffect(() => {
//     if (paymentStatus === "Approved") {
//       fetchPaymentStatus();
//     }
//   }, [paymentStatus]);

//   useEffect(() => {
//     if (internshipDetails && paymentStatus === "Approved") {
//       fetchPaymentStatus();
//     }
//   }, [internshipDetails, paymentStatus]);

//   const renderApplicationButton = () => {
//     const buttonBaseStyle = {
//       w: "full",
//       h: isMobile ? "50px" : "60px",
//       borderRadius: "15px",
//       boxShadow: "lg",
//       fontSize: isMobile ? "lg" : "xl",
//     };

//     if (paymentStatus === "Approved" && !isPaymentCompleted) {
//       return (
//         <Button
//           bg="green.600"
//           color="white"
//           _hover={{ bg: "green.800" }}
//           {...buttonBaseStyle}
//           onClick={handlePayment}
//         >
//           Pay Now
//         </Button>
//       );
//     } else if (paymentStatus === "Approved" && isPaymentCompleted) {
//       return (
//         <Button
//           bg="green.800"
//           _hover={{ bg: "green.700" }}
//           color="white"
//           {...buttonBaseStyle}
//           isDisabled
//         >
//           Payment Completed
//         </Button>
//       );
//     } else if (paymentStatus === "Rejected") {
//       return (
//         <Button
//           bg="red.900"
//           _hover={{ bg: "red.600" }}
//           color="white"
//           {...buttonBaseStyle}
//           isDisabled
//         >
//           Application Rejected
//         </Button>
//       );
//     } else if (paymentStatus === "Pending" || hasApplied) {
//       return (
//         <Button
//           bg="#D69E2E"
//           color="white"
//           _hover={{ bg: "#B7791F" }}
//           {...buttonBaseStyle}
//           isDisabled
//         >
//           Awaiting Approval
//         </Button>
//       );
//     } else {
//       return (
//         <>
//           {!showResumeUpload ? (
//             <Button
//               bg="blue.900"
//               color="white"
//               _hover={{ bg: "blue.700" }}
//               {...buttonBaseStyle}
//               onClick={() => setShowResumeUpload(true)}
//               isDisabled={isLoading}
//             >
//               {isLoading ? <Spinner size="sm" mr={2} /> : null}
//               Apply for internship
//             </Button>
//           ) : (
//             <VStack w="full" spacing={4} align="center">
//               {showResumeAlert && (
//                 <Alert status="warning" borderRadius="md">
//                   <AlertIcon />
//                   Please upload your resume before completing the application
//                 </Alert>
//               )}
//               <VStack spacing={3} w="full">
//                 <Button
//                   w={{ base: "100%", md: "300px" }}
//                   h={isMobile ? "40px" : "50px"}
//                   as="label"
//                   htmlFor="resume-upload"
//                   cursor="pointer"
//                   bg="purple"
//                   color="white"
//                   _hover={{ bg: "purple.900" }}
//                   isLoading={isLoading}
//                 >
//                   Upload Resume
//                   <Input
//                     id="resume-upload"
//                     type="file"
//                     accept=".pdf"
//                     onChange={handleResumeUpload}
//                     display="none"
//                   />
//                 </Button>
//                 <Button
//                   w={{ base: "100%", md: "300px" }}
//                   h={isMobile ? "40px" : "50px"}
//                   bg="blue.600"
//                   color="white"
//                   _hover={{ bg: "blue" }}
//                   onClick={handleCompleteApplication}
//                   isDisabled={isLoading}
//                 >
//                   Apply Now
//                 </Button>
//               </VStack>
//             </VStack>
//           )}
//         </>
//       );
//     }
//   };

//   return (
//     <div>
//       <NavBar isAdmin={isAdmin} />
//       <Heading textAlign="center" fontSize={{ base: "3xl", md: "5xl" }} fontWeight="bold" mt={8} mb={6} color="#3c8c30">
//         Internship Overview
//       </Heading>
//       <Box
//         w={{ base: "95%", md: "70%" }}
//         mx="auto"
//         mt={6}
//         bg="rgba(52, 109, 194, 0.8)"
//         p={{ base: 4, md: 8 }}
//         borderRadius="20px"
//         boxShadow="xl"
//       >
//         <Flex direction={{ base: "column", md: "row" }} align="center" gap={{ base: 4, md: 8 }}>
//           <VStack align="start" spacing={4} w={{ base: "100%", md: "60%" }}>
//             <Text fontSize={{ base: "2xl", md: "4xl" }} fontWeight="bold" color="#f8f9fa">
//               {internshipDetails?.Internship_title}
//             </Text>
//             <Text fontSize={{ base: "md", md: "xl" }} color="#f8f9fa">
//               Become an expert and enhance your resume
//             </Text>
//             <Text fontSize={{ base: "sm", md: "lg" }} color="#f8f9fa">
//               <b>Duration:</b> {internshipDetails?.duration_weeks} weeks <br />
//               <b>Skills to learn:</b> {internshipDetails?.key_skills}
//             </Text>

//             {renderApplicationButton()}

//           </VStack>

//           <Image
//             src={course || "/placeholder.svg"}
//             alt="Internship"
//             borderRadius="15px"
//             maxWidth={{ base: "80%", md: "45%", lg: "400px" }}
//             maxHeight={{ base: "auto", md: "auto", lg: "400px" }}
//             objectFit="contain"
//             boxShadow="md"
//             mt={{ base: 4, md: 0 }}
//           />
//         </Flex>

//         <Box mt={8} bg="#f8f9fa" p={6} borderRadius="15px" boxShadow="lg">
//           <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" color="#2c3e50" mb={2}>
//             About the Internship
//           </Text>
//           <OrderedList mt={3} spacing={2} fontSize={{ base: "md", md: "lg" }}>
//             <ListItem>Internship Type: {internshipDetails?.internship_type}</ListItem>
//             {internshipDetails?.project_count > 0 && <ListItem>{internshipDetails.project_count} Project(s)</ListItem>}
//             {internshipDetails?.lor && <ListItem>LOR</ListItem>}
//             {internshipDetails?.completion_certificate && <ListItem>Certificate of Completion</ListItem>}
//             {internshipDetails?.paper_writing && <ListItem>Publication/Paper Writing</ListItem>}
//             <ListItem>Duration: {internshipDetails?.duration_weeks} weeks</ListItem>
//             <ListItem>Fees: ₹{internshipDetails?.fees}</ListItem>
//             <ListItem>Expert Mentors</ListItem>
//           </OrderedList>

//           {/* Paste the Ad Unit code here  */}
//           <Center mt={6}>
//             <ins className="adsbygoogle"
//               style={{ display: 'inline-block', width: '628px', height: '90px' }}
//               data-ad-client="ca-pub-6169839016655974"
//               data-ad-slot="8384891472"></ins>
//             <script>
//               (adsbygoogle = window.adsbygoogle || []).push({ });
//             </script>
//           </Center>

//         </Box>
//       </Box>

//       <Box
//         w="full"
//         mt={8}
//         bgGradient="linear(to-r,rgb(85, 148, 230),rgb(91, 150, 226))"
//         p={8}
//         textAlign="center"
//         color="white"
//       >
//         <Text fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold" mb={6}>
//           Why is this internship the right choice for you?
//         </Text>
//         <Flex justify="center" wrap="wrap" mt={4} gap={6}>
//           {[
//             "🎯 Personalized cover letter, resume building, interview preparation & corporate referrals to boost your confidence.",
//             "🌐 Build real industry connections, collaborate with professionals that accelerate your growth and long-term career trajectory",
//             "💻 Learn by doing - build real-world projects, solve hands-on challenges, and sharpen your coding skills through expert-curated tasks and guidance.",
//             "🛠️ Experience hands-on learning, develop in-demand skills, and explore your ideal career path through real-world challenges.",
//           ].map((text, index) => (
//             <Box
//               key={index}
//               w={{ base: "90%", md: "300px" }}
//               h="auto"
//               minH="200px"
//               bg="rgba(4, 11, 26, 0.3)"
//               borderRadius="15px"
//               p={4}
//               boxShadow="lg"
//               backdropFilter="blur(10px)"
//               textAlign="center"
//               position="relative"
//               transition="all 0.3s ease-in-out"
//               _hover={{
//                 transform: "scale(1.05)",
//                 boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.3)",
//               }}
//             >
//               <Text fontSize={{ base: "md", md: "lg" }} fontWeight="bold" mb={3}>
//                 {text}
//               </Text>
//               <Image src={bars || "/placeholder.svg"} alt="Icon" mt={2} boxSize="40px" mx="auto" />
//             </Box>
//           ))}
//         </Flex>
//       </Box>

//       <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} isCentered>
//         <ModalOverlay backdropFilter="blur(10px)" />
//         <ModalContent>
//           <ModalHeader>Processing</ModalHeader>
//           <ModalBody pb={6}>
//             <Flex direction="column" align="center" justify="center">
//               <Spinner size="xl" color="blue.500" mb={4} />
//               <Text>Please wait while we process your request...</Text>
//             </Flex>
//           </ModalBody>
//         </ModalContent>
//       </Modal>

//       {/* <Footer /> */}
//     </div>
//   );
// };

// export default IDetail;

import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Heading,
  Box,
  Text,
  Flex,
  VStack,
  Button,
  Image,
  Spacer,
  OrderedList,
  ListItem,
  useToast,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Spinner,
  Input,
  Alert,
  AlertIcon,
  useMediaQuery,
} from "@chakra-ui/react";
import course from "../images/girl.gif";
import bars from "../images/bars.png";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";

const IDetail = () => {
  const { id } = useParams();
  const [internshipDetails, setInternshipDetails] = useState(null);
  const { isAdmin } = useSelector((state) => state.user);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [isPaymentCompleted, setIsPaymentCompleted] = useState(false);
  const [showResumeUpload, setShowResumeUpload] = useState(false);
  const [hasApplied, setHasApplied] = useState(false);
  const [resumeUploaded, setResumeUploaded] = useState(false);
  const [showResumeAlert, setShowResumeAlert] = useState(false);


  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const [isMobile] = useMediaQuery("(max-width: 900px)");
  const [isTablet] = useMediaQuery("(max-width: 1070px)");

  const handlePaymentStatus = async () => {
    const accessToken = window.sessionStorage.getItem("accessToken");
    const merchant_id = window.sessionStorage.getItem("merchant_id");

    if (!merchant_id) {
      toast({
        title: "Error",
        description: "Merchant ID is missing.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    try {
      const response = await axios.post(
        "https://gyanbackend.aim4u.co.in/intern/payment-status/",
        { merchant_order_id: merchant_id },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const { status, details } = response.data;

      if (status === "Payment incomplete or failed") {
        const errorDetails = details?.error_code
          ? `Error Code: ${details.error_code}`
          : "Please try again later.";

        toast({
          title: "Payment Failed",
          description: errorDetails,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } else if (details?.status === "PENDING") {
        toast({
          title: "Payment Pending",
          description: "Your payment is still being processed. Please wait a few minutes.",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
      } else if (details?.status === "SUCCESS") {
        setIsPaymentCompleted(true);
        toast({
          title: "Payment Successful",
          description: `Order ID: ${details.order_id}`,
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: error.response?.data?.message || "Failed to fetch payment status.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error("Payment status error:", error);
    }
  };

  const handlePayment = async () => {
    if (!id) {
      toast({
        title: "Error",
        description: "Internship ID is missing",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    setIsLoading(true);
    onOpen();

    try {
      const accessToken = window.sessionStorage.getItem("accessToken");

      const response = await axios.post(
        "https://gyanbackend.aim4u.co.in/intern/gyan-payment/",
        { internship_id: id },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data && response.data.redirect_url) {
        window.sessionStorage.setItem("merchant_id", response.data.merchant_order_id);

        setTimeout(() => {
          setIsLoading(false);
          onClose();
          window.location.href = response.data.redirect_url;

          setTimeout(() => {
            handlePaymentStatus();
          }, 3000);
        }, 1500);
      } else {
        throw new Error("No redirect URL received from payment gateway");
      }
    } catch (error) {
      setIsLoading(false);
      onClose();

      toast({
        title: "Payment Failed",
        description: error.response?.data?.message || "Something went wrong with the payment process",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error("Payment error:", error);
    }
  };
  const handleResumeUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedFileType = "application/pdf";


    if (file.type !== allowedFileType) {
      toast({
        title: "Invalid File Type",
        description: "Please upload a PDF file.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }



    setIsLoading(true);
    const reader = new FileReader();
    reader.onload = () => {
      localStorage.setItem("user_resume", reader.result);
      setResumeUploaded(true);
      setShowResumeAlert(false);
      setIsLoading(false);

      toast({
        title: "Resume Uploaded",
        description: "Your resume has been successfully uploaded",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    };
    reader.onerror = () => {
      setIsLoading(false);
      toast({
        title: "Error",
        description: "Failed to upload resume",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    };
    reader.readAsDataURL(file);
  };


  const handleCompleteApplication = () => {
    if (!resumeUploaded) {
      setShowResumeAlert(true);
      return;
    }
    handleApply();
  };

  const handleApply = async () => {
    if (!id) {
      toast({
        title: "Error",
        description: "Internship ID is missing",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }


    setIsLoading(true);


    const processingToast = toast({
      title: "Processing",
      description: "Submitting your application...",
      status: "info",
      duration: null,
      isClosable: false,
    });

    try {
      const accessToken = window.sessionStorage.getItem("accessToken");
      const resumeData = localStorage.getItem("user_resume");

      // First apply for the internship
      const applyResponse = await axios.post(
        "https://gyanbackend.aim4u.co.in/intern/apply/",
        { internship_id: id },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Then upload the resume if available
      if (resumeData) {
        const blob = await fetch(resumeData).then(r => r.blob());
        const user = JSON.parse(sessionStorage.getItem("user"));

        const file = new File([blob], "resume.pdf", { type: "application/pdf" });

        const formData = new FormData();
        formData.append("internship_id", id);
        formData.append("resume_file", file);

        await axios.post(
          "https://gyanbackend.aim4u.co.in/upload-internship-resume/",
          formData,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }

      // Close the processing toast
      toast.close(processingToast);

      toast({
        title: "Success",
        description: applyResponse.data.message,
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      setHasApplied(true);
      setShowResumeUpload(false);
      setIsLoading(false);
      fetchApplicationStatus();
    } catch (error) {
      // Close the processing toast
      toast.close(processingToast);

      setIsLoading(false);

      toast({
        title: "Apply Failed",
        description:
          error.response?.data?.message ||
          "Something went wrong while applying",
        status: "error",
        duration: 5000,
        isClosable: true,
      });

      console.error("Apply error:", error);
    }
  };

  const fetchInternshipDetails = async () => {
    try {
      const response = await axios.get("https://gyanbackend.aim4u.co.in/intern/all-internship/");
      const selectedInternship = response.data.find(
        (internship) => internship.id === Number.parseInt(id, 10)
      );

      if (selectedInternship) {
        setInternshipDetails(selectedInternship);
      }
    } catch (error) {
      console.error("Error fetching internship details:", error);
      toast({
        title: "Error",
        description: "Failed to load internship details",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const fetchApplicationStatus = async () => {
    try {
      const currentUser = JSON.parse(sessionStorage.getItem("user"));
      const internshipTitle = internshipDetails?.Internship_title;

      if (!currentUser || !internshipTitle) return;

      const response = await axios.get("https://gyanbackend.aim4u.co.in/intern/get-status/", {
        params: {
          user: currentUser.email,
          internship: internshipTitle,
        },
      });

      setPaymentStatus(response.data.status);
    } catch (error) {
      console.error("Error fetching payment status:", error);
      setPaymentStatus("Unavailable");
    }
  };

  const fetchPaymentStatus = async () => {
    try {
      const currentUser = JSON.parse(sessionStorage.getItem("user"));
      const internshipTitle = internshipDetails?.Internship_title;

      if (!currentUser || !internshipTitle) return;

      const response = await axios.get("https://gyanbackend.aim4u.co.in/intern/get-payment-status/", {
        params: {
          user: currentUser.email,
          internship: internshipTitle,
        },
      });

      if (response.data.payment_status === "COMPLETED") {
        setIsPaymentCompleted(true);
      } else {
        setIsPaymentCompleted(false);
      }
    } catch (error) {
      console.error("Error fetching payment status:", error);
      setIsPaymentCompleted(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchInternshipDetails();
    }
  }, [id, toast]);

  useEffect(() => {
    if (internshipDetails) {
      fetchApplicationStatus();
    }
  }, [internshipDetails]);

  useEffect(() => {
    if (document.referrer?.includes("phonepe")) {
      console.log("FROM PHONEPE");
      handlePaymentStatus();
      fetchPaymentStatus();
    }
  }, []);

  useEffect(() => {
    if (paymentStatus === "Approved") {
      fetchPaymentStatus();
    }
  }, [paymentStatus]);

  useEffect(() => {
    if (internshipDetails && paymentStatus === "Approved") {
      fetchPaymentStatus();
    }
  }, [internshipDetails, paymentStatus]);

  const renderApplicationButton = () => {
    const buttonBaseStyle = {
      w: "full",
      h: isMobile ? "50px" : "60px",
      borderRadius: "15px",
      boxShadow: "lg",
      fontSize: isMobile ? "lg" : "xl",
    };

    if (paymentStatus === "Approved" && !isPaymentCompleted) {
      return (
        <Button
          bg="green.600"
          color="white"
          _hover={{ bg: "green.800" }}
          {...buttonBaseStyle}
          onClick={handlePayment}
        >
          Pay Now
        </Button>
      );
    } else if (paymentStatus === "Approved" && isPaymentCompleted) {
      return (
        <Button
          bg="green.800"
          _hover={{ bg: "green.700" }}
          color="white"
          {...buttonBaseStyle}
          isDisabled
        >
          Payment Completed
        </Button>
      );
    } else if (paymentStatus === "Rejected") {
      return (
        <Button
          bg="red.900"
          _hover={{ bg: "red.600" }}
          color="white"
          {...buttonBaseStyle}
          isDisabled
        >
          Application Rejected
        </Button>
      );
    } else if (paymentStatus === "Pending" || hasApplied) {
      return (
        <Button
          bg="#D69E2E"
          color="white"
          _hover={{ bg: "#B7791F" }}
          {...buttonBaseStyle}
          isDisabled
        >
          Awaiting Approval
        </Button>
      );
    } else {
      return (
        <>
          {!showResumeUpload ? (
            <Button
              bg="blue.900"
              color="white"
              _hover={{ bg: "blue.700" }}
              {...buttonBaseStyle}
              onClick={() => setShowResumeUpload(true)}
              isDisabled={isLoading}
            >
              {isLoading ? <Spinner size="sm" mr={2} /> : null}
              Apply for internship
            </Button>
          ) : (
            <VStack w="full" spacing={6} align="center">
              <Box
                border="2px dashed #3182CE"
                borderRadius="lg"
                p={6}
                textAlign="center"
                bg="#f0f8ff"
                w="100%"
                maxW="500px"
              >
                <Text fontSize="lg" fontWeight="bold" mb={2} color="gray.700">
                  Upload Your Resume
                </Text>
                {/* <Text fontSize="sm" color="gray.500" mb={4}>
                Only PDF files are allowed. The file name should be <b>yourname_resume.pdf</b>.
              </Text> */}

                <OrderedList textAlign="left" color="gray.600" fontSize="sm" mb={4} ml="10%">
                  <ListItem>Accepted file type: <b>.pdf</b></ListItem>
                  <ListItem>File name format: <b>yourname_resume.pdf</b></ListItem>
                  {/* <ListItem>Include your updated contact info and projects</ListItem> */}
                </OrderedList>

                <Input
                  type="file"
                  accept="application/pdf"
                  display="none"
                  id="resumeUploadInput"
                  onChange={handleResumeUpload}
                />
                <label htmlFor="resumeUploadInput">
                  <Button
                    colorScheme="blue"
                    as="span"
                    size="md"
                    isLoading={isLoading}
                  >
                    {resumeUploaded ? "Resume Uploaded" : "Upload"}
                  </Button>
                </label>

                {showResumeAlert && (
                  <Alert status="warning" mt={4} borderRadius="md">
                    <AlertIcon />
                    Please upload a valid resume to continue.
                  </Alert>
                )}
              </Box>

              <Button
                w={{ base: "100%", md: "300px" }}
                h={isMobile ? "40px" : "50px"}
                bg="blue.900"
                color="white"
                _hover={{ bg: "blue.400" }}
                onClick={handleCompleteApplication}
                isDisabled={isLoading}
              >
                Apply Now
              </Button>
            </VStack>
          )}
        </>
      );
    }
  };



  return (
    <div>
      <NavBar isAdmin={isAdmin} />
      <Heading textAlign="center" fontSize={{ base: "3xl", md: "5xl" }} fontWeight="bold" mt={8} mb={6} color="#3c8c30">
        Internship Overview
      </Heading>
      <Box
        w={{ base: "95%", md: "70%" }}
        mx="auto"
        mt={6}
        bg="rgba(52, 109, 194, 0.8)"
        p={{ base: 4, md: 8 }}
        borderRadius="20px"
        boxShadow="xl"
      >
        <Flex direction={{ base: "column", md: "row" }} align="center" gap={{ base: 4, md: 8 }}>
          <VStack align="start" spacing={4} w={{ base: "100%", md: "60%" }}>
            <Text fontSize={{ base: "2xl", md: "4xl" }} fontWeight="bold" color="#f8f9fa">
              {internshipDetails?.Internship_title}
            </Text>
            <Text fontSize={{ base: "md", md: "xl" }} color="#f8f9fa">
              Build skills and strengthen your resume through internship activities.
            </Text>
            <Text fontSize={{ base: "sm", md: "lg" }} color="#f8f9fa">
              <b>Duration:</b> {internshipDetails?.duration_weeks} weeks <br />
              <b>Skills to learn:</b> {internshipDetails?.key_skills}
            </Text>

            {renderApplicationButton()}

          </VStack>

          <Image
            src={course || "/placeholder.svg"}
            alt="Internship"
            borderRadius="15px"
            maxWidth={{ base: "80%", md: "45%", lg: "400px" }}
            maxHeight={{ base: "auto", md: "auto", lg: "400px" }}
            objectFit="contain"
            boxShadow="md"
            mt={{ base: 4, md: 0 }}
          />
        </Flex>

        <Box mt={8} bg="#f8f9fa" p={6} borderRadius="15px" boxShadow="lg">
          <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" color="#2c3e50" mb={2}>
            About the Internship
          </Text>
          <OrderedList mt={3} spacing={2} fontSize={{ base: "md", md: "lg" }}>
            <ListItem>Eligibility Criteria: {internshipDetails?.eligibility_criteria}</ListItem>
            <ListItem>Internship Type: {internshipDetails?.Internship_type}</ListItem>
            {internshipDetails?.project_count > 0 && <ListItem>{internshipDetails.project_count} Project(s)</ListItem>}
            {internshipDetails?.lor && (
              <ListItem>
                Letters of Recommendation may be considered for strong performance and meaningful contributions; issuance is not guaranteed.
              </ListItem>
            )}
            {internshipDetails?.completion_certificate && (
              <ListItem>Certificate of Completion, subject to programme requirements</ListItem>
            )}
            {internshipDetails?.paper_writing && <ListItem>Publication/Paper Writing</ListItem>}
            <ListItem>Duration: {internshipDetails?.duration_weeks} weeks</ListItem>
            <ListItem>Fees: ₹{internshipDetails?.fees}</ListItem>
            <ListItem>Guidance and feedback vary by internship track</ListItem>
          </OrderedList>
        </Box>
      </Box>

      <Box
        w="full"
        mt={8}
        bgGradient="linear(to-r,rgb(85, 148, 230),rgb(91, 150, 226))"
        p={8}
        textAlign="center"
        color="white"
      >
        <Text fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold" mb={6}>
          Why is this internship the right choice for you?
        </Text>
        <Flex justify="center" wrap="wrap" mt={4} gap={6}>
          {[
            "🎯 Personalized cover letter, resume building, interview preparation & corporate referrals to boost your confidence.",
            "🌐 Build real industry connections, collaborate with professionals that accelerate your growth and long-term career trajectory",
            "💻 Learn by doing - build real-world projects, solve hands-on challenges, and sharpen your coding skills through expert-curated tasks and guidance.",
            "🛠️ Experience hands-on learning, develop in-demand skills, and explore your ideal career path through real-world challenges.",
          ].map((text, index) => (
            <Box
              key={index}
              w={{ base: "90%", md: "300px" }}
              h="auto"
              minH="200px"
              bg="rgba(4, 11, 26, 0.3)"
              borderRadius="15px"
              p={4}
              boxShadow="lg"
              backdropFilter="blur(10px)"
              textAlign="center"
              position="relative"
              transition="all 0.3s ease-in-out"
              _hover={{
                transform: "scale(1.05)",
                boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.3)",
              }}
            >
              <Text fontSize={{ base: "md", md: "lg" }} fontWeight="bold" mb={3}>
                {text}
              </Text>
              <Image src={bars || "/placeholder.svg"} alt="Icon" mt={2} boxSize="40px" mx="auto" />
            </Box>
          ))}
        </Flex>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} isCentered>
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>Processing</ModalHeader>
          <ModalBody pb={6}>
            <Flex direction="column" align="center" justify="center">
              <Spinner size="xl" color="blue.500" mb={4} />
              <Text>Please wait while we process your request...</Text>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* <Footer /> */}
    </div>
  );
};

export default IDetail;